/**
 * Desktop breakpoint. At >= 1024px the app switches from the phone layout
 * (430px column + bottom tab bar) to the website layout (sidebar + wide
 * content). Matches Tailwind's `lg:` so CSS and JS agree on the cut-over.
 */

import { useEffect, useState } from 'react';

const QUERY = '(min-width: 1024px)';

export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(QUERY).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = () => setIsDesktop(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return isDesktop;
}
